module.exports = "<!--The content below is only a placeholder and can be replaced.-->\r\n<ngx-ui-loader></ngx-ui-loader>\r\n<router-outlet></router-outlet>\r\n"